import { generateRedirectUrl } from '@domain-group/javascript-utils'

import { DashboardModuleListItem } from '@domain-group/suit-theme'

import useAgencyPortal from '@hooks/useAgencyPortal'
import { generateUrls } from '@hooks/usePortal'

import { AgencyPortalModel } from '@models/agencyPortal'

import AgencyPortalActions from '../AgencyPortalActions'

type AgencyPortalListItemProps = {
  agencyPortal: AgencyPortalModel,
  assignedPortalIds: [],
}

const AgencyPortalListItem = (props: AgencyPortalListItemProps) => {
  const {
    agencyPortal: initAgencyPortal,
    assignedPortalIds,
  } = props

  const useAgencyPortalPayload = useAgencyPortal(initAgencyPortal)

  const {
    agencyPortal: {
      identity_code,
    },
    portal,
  } = useAgencyPortalPayload

  const { title } = portal

  const { editPortalUrl } = generateUrls(portal)

  return (
    <DashboardModuleListItem
      secondaryText={identity_code}
      title={title}
    >
      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.Actions>
        <AgencyPortalActions assignedPortalIds={assignedPortalIds} useAgencyPortalPayload={useAgencyPortalPayload} />

        {/*
         // @ts-expect-error TS2339 */}
        <DashboardModuleListItem.Icon
          boxProps={{ marginLeft: 'medium' }}
          href={`${editPortalUrl}?redirect=${generateRedirectUrl()}`}
          type="link"
        />
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.Actions>
    </DashboardModuleListItem>
  )
}

export default AgencyPortalListItem
